import { render } from "./BCardHeadFoot.vue?vue&type=template&id=e7e6b092&ts=true"
import script from "./BCardHeadFoot.vue?vue&type=script&lang=ts"
export * from "./BCardHeadFoot.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__